import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

import ToolTipList from '../ToolTipList/ToolTipList'

const CategoriesChip = ({ categories, isEnabled }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const getLabel = () => {
    if (categories?.length) {
      return `${categories.length} ${categories.length > 1 ? t('categorías de producto') : t('categoría de producto')}`
    }

    return t('Todas las categorías')
  }

  return (
    <Chip
      label={getLabel()}
      disabled={!isEnabled}
      backgroundColor={theme.colors.warning.surface}
      color={theme.colors.warning.onSurface}
      tooltipContent={categories?.length > 0 && <ToolTipList items={categories.map(category => category?.name)} />}
    />
  )
}

export default CategoriesChip
